var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_12",
    "data-name": "\\uADF8\\uB8F9 12",
    transform: "translate(-1154 -457)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_21",
    "data-name": "\\uC0AC\\uAC01\\uD615 21",
    width: 36,
    height: 36,
    transform: "translate(1154 457)",
    fill: "#ff4848",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye",
    "data-name": "Icon awesome-eye",
    d: "M19.1,10.417A10.7,10.7,0,0,0,9.606,4.5a10.7,10.7,0,0,0-9.49,5.918,1.079,1.079,0,0,0,0,.974,10.7,10.7,0,0,0,9.49,5.917,10.7,10.7,0,0,0,9.49-5.918A1.079,1.079,0,0,0,19.1,10.417Zm-9.49,5.29a4.8,4.8,0,1,1,4.8-4.8A4.8,4.8,0,0,1,9.606,15.707Zm0-8.005a3.179,3.179,0,0,0-.844.126A1.6,1.6,0,0,1,6.531,10.06,3.195,3.195,0,1,0,9.606,7.7Z",
    transform: "translate(1162.394 464.096)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShow);
export default __webpack_public_path__ + "static/media/eye-show.01980d67d69aec8ecf636b8f764a6fb3.svg";
export { ForwardRef as ReactComponent };